var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9146 17.2103C10.6406 17.2103 11.2292 16.6217 11.2292 15.8957C11.2292 15.1696 10.6406 14.5811 9.9146 14.5811C9.18857 14.5811 8.6 15.1696 8.6 15.8957C8.6 16.6217 9.18857 17.2103 9.9146 17.2103Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89283 12.6247C9.67656 12.6249 9.46854 12.5417 9.31207 12.3924C9.1556 12.2431 9.06274 12.0392 9.05283 11.8232L8.75533 5.6051C8.7488 5.44899 8.77398 5.29317 8.82934 5.14706C8.88471 5.00095 8.9691 4.86757 9.07744 4.75498C9.18578 4.64239 9.31581 4.55292 9.45968 4.49198C9.60355 4.43104 9.75828 4.39988 9.91453 4.4004C10.071 4.40041 10.2259 4.43219 10.3698 4.49381C10.5137 4.55544 10.6435 4.64563 10.7515 4.75892C10.8595 4.87221 10.9434 5.00624 10.998 5.15289C11.0527 5.29954 11.077 5.45577 11.0695 5.6121L10.7286 11.8288C10.7174 12.0431 10.6245 12.245 10.4691 12.393C10.3136 12.541 10.1075 12.6239 9.89283 12.6247Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.d88877a1.svg";
export { ForwardRef as ReactComponent };